<template>
  <v-row>
    <!-- kitchen sink
    - ${$t('menu.comitions')}
    -->
    <v-col cols="12">
      <app-card-code :title="`${$t('menu.gestion')} / ${$t('menu.markups')}`">
        <MarkupsList></MarkupsList>
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

import MarkupsList from './tablas/MarkupsList.vue'

export default {
  components: {
    AppCardCode,
    MarkupsList,
  },
}
</script>
